import { TranslateModule } from '@ngx-translate/core';
import { AppFloatingConfigurator } from 'app/layout/component/app.floatingconfigurator';
import { ButtonModule } from 'primeng/button';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [RouterModule, AppFloatingConfigurator, ButtonModule, TranslateModule],
  template: ` <app-floating-configurator />
    <div class="flex min-h-screen items-center justify-center overflow-hidden">
      <div class="flex flex-col items-center justify-center">
        <img
          src="assets/images/applogo.svg"
          alt="Logo"
          class="mb-8 h-12 w-auto shrink-0"
        />
        <div
          style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, color-mix(in srgb, var(--primary-color), transparent 60%) 10%, var(--surface-ground) 30%)"
        >
          <div
            class="flex w-full flex-col items-center bg-surface-0 px-8 py-20 sm:px-20 dark:bg-surface-900"
            style="border-radius: 53px"
          >
            <span class="text-3xl font-bold text-primary">404</span>
            <h1 class="mb-2 text-3xl font-bold text-surface-900 lg:text-5xl dark:text-surface-0">{{ 'auth.notFound.title' | translate }}</h1>
            <div class="mb-8 text-surface-600 dark:text-surface-200">{{ 'auth.notFound.message' | translate }}</div>
            <!--
                        <a routerLink="/" class="w-full flex items-center py-8 border-surface-300 dark:border-surface-500 border-b">
                            <span class="flex justify-center items-center border-2 border-primary text-primary rounded-border" style="height: 3.5rem; width: 3.5rem">
                                <i class="pi pi-fw pi-table !text-2xl"></i>
                            </span>
                            <span class="ml-6 flex flex-col">
                                <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0 block">Frequently Asked Questions</span>
                                <span class="text-surface-600 dark:text-surface-200 lg:text-xl">Ultricies mi quis hendrerit dolor.</span>
                            </span>
                        </a>
                        <a routerLink="/" class="w-full flex items-center py-8 border-surface-300 dark:border-surface-500 border-b">
                            <span class="flex justify-center items-center border-2 border-primary text-primary rounded-border" style="height: 3.5rem; width: 3.5rem">
                                <i class="pi pi-fw pi-question-circle !text-2xl"></i>
                            </span>
                            <span class="ml-6 flex flex-col">
                                <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0">Solution Center</span>
                                <span class="text-surface-600 dark:text-surface-200 lg:text-xl">Phasellus faucibus scelerisque eleifend.</span>
                            </span>
                        </a>
                        <a routerLink="/" class="w-full flex items-center mb-8 py-8 border-surface-300 dark:border-surface-500 border-b">
                            <span class="flex justify-center items-center border-2 border-primary text-primary rounded-border" style="height: 3.5rem; width: 3.5rem">
                                <i class="pi pi-fw pi-unlock !text-2xl"></i>
                            </span>
                            <span class="ml-6 flex flex-col">
                                <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0">Permission Manager</span>
                                <span class="text-surface-600 dark:text-surface-200 lg:text-xl">Accumsan in nisl nisi scelerisque</span>
                            </span>
                        </a>
                        -->
            <p-button
              [label]="'auth.notFound.goDashboard' | translate"
              routerLink="/"
            />
          </div>
        </div>
      </div>
    </div>`
})
export class Notfound {}
